import { Button } from "antd";
import { useContext, useEffect, useState } from "react";
import useLocalTracks from "../../hooks/useLocalTracks";

import { RoomContext, participantLayout } from "../../RoomContext";
import Actions from "../Actions";
import Grid from "../ParticipantLayouts/Grid";
import Sidebar from "../ParticipantLayouts/Sidebar";
import Spotlight from "../ParticipantLayouts/Spotlight";

const Room = () => {
  const { display, disconnectFromRoom, videoEnabled, audioEnabled } =
    useContext(RoomContext);

  const { videoTrack, audioTrack } = useLocalTracks();

  useEffect(() => {
    if (!videoEnabled) {
      videoTrack.disable();
    }
    if (!audioEnabled) {
      audioTrack.disable();
    }
    window.addEventListener("beforeunload", () => {
      disconnectFromRoom();
    });
  }, []);

  const layout = () => {
    switch (display) {
      case participantLayout.sidebar:
        return <Sidebar />;
      case participantLayout.tiled:
        return <Grid />;
      case participantLayout.spotlight:
        return <Spotlight />;
    }
  };

  useEffect(() => {
    window.addEventListener("beforeunload", disconnectFromRoom);
    return () => {
      window.removeEventListener("beforeunload", disconnectFromRoom);
    };
  }, []);

  return (
    <>
      <div className="participants">{layout()}</div>
      <Actions />
    </>
  );
};

export default Room;
